<template>
  <v-card flat>
    <v-card-text>
      <v-toolbar flat>
        <v-toolbar-title>Add Devices</v-toolbar-title>
      </v-toolbar>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="subscriptionsNotConnectedToUser"
      item-key="id"
      show-select
      :search="search"
      sort-by="unit.alias"
    >

      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            :disabled="disabled"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-toolbar>
      </template>

      <template v-slot:header.data-table-select="{ on, props }">
        <v-simple-checkbox :disabled="disabled" :ripple="false" v-bind="props" v-on="on"/>
      </template>

      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :disabled="disabled" :ripple="false" :value="isSelected" @input="select($event)"/>
      </template>

      <template v-slot:item.loadingBar="{ item }">
        <v-progress-circular v-if="item.loading" indeterminate color="loading"/>
      </template>

      <template v-slot:item.transientFamily="{ item }">
        <v-icon>{{getFamilyIcon(item.unit.transientFamily)}}</v-icon>
      </template>

    </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="closeForm" type='btn' :disabled="disabled" class="secondary">
        cancel
      </v-btn>
      <v-btn @click="addSubscriptions" type='submit' :disabled="selected.length === 0 || disabled" class="primary">
        Add devices
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import bulkOperation from '../../mixins/bulkOperation'
import familyIcon from '../../mixins/familyIcon'

export default {
  name: 'AddSubscriptionsForm',
  mixins: [bulkOperation, familyIcon],
  data: () => ({
    selected: [],
    disabled: false,
    search: '',
    headers: [
      {
        text: '',
        align: 'left',
        dense: true,
        value: 'transientFamily',
        sortable: false
      },
      {
        text: 'Alias',
        value: 'unit.alias'
      },
      {
        text: 'Note',
        value: 'unit.notes'
      },
      {
        text: 'Subscription number',
        value: 'subscriptionNumber'
      },
      {
        text: '',
        value: 'loadingBar',
        sortable: false
      }
    ]
  }),
  methods: {
    closeForm: function () {
      this.resetData()
      this.$emit('close-form')
    },

    resetData: function () {
      this.search = ''
      this.selected = []
    },

    addSubscriptions: function () {
      this.beforeAddSubscriptions()
      this.$store.dispatch('customer/createInvitation', { email: this.userEmail, subscriptionIds: this.selected.map(x => x.id) })
        .then(res => {
          this.handleAddSubscriptionsSuccess(res)
        })
        .catch(err => {
          this.handleAddSubscriptionsError(err)
        })
        .finally(() => {
          this.afterAddSubscriptions()
        })
    },

    beforeAddSubscriptions: function () {
      this.disabled = true
      for (let subscription of this.selected) {
        subscription.loading = true
      }
    },

    handleAddSubscriptionsError: function (error) {
      console.error(error)
      this.$store.commit('setErrorMessages', error)
    },

    handleAddSubscriptionsSuccess: function (invite) {
      let subscriptions = ''
      for (let subscription of invite.subscriptions) {
        subscriptions += subscription.unit.alias + ', '
      }
      subscriptions = subscriptions.substr(0, subscriptions.length - 2)
      this.$store.commit('setSuccessMessage', 'Invites has been successfully created for: ' + invite.email + ' for the following devices: ' + subscriptions)
    },

    afterAddSubscriptions: function () {
      this.disabled = false
      for (let subscription of this.selected) {
        subscription.loading = false
      }
      this.selected = []
      this.$emit('close-form')
    }
  },
  computed: {
    subscriptionsNotConnectedToUser: function () {
      return this.$store.getters['user/subscriptionsNotConnectedToUser']
    },
    userEmail: function () {
      return this.$store.state.user.currentUser.data.email
    }
  }
}
</script>

<style scoped>

</style>
